<template>
  <create-dialog
    width="60%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-6 col-xl-6`">
          <fg-input
            :label="`${$t('sowing.distancing_type')}: *`"
            class="shadow-sm"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="sowing.nursery"
            :error="getError('sowing.nursery', true)"
            :placeholder="`${$t('common_words.name')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-lg-6 col-xl-6`">
          <fg-input
            :label="`${$t('common_words.long')}: *`"
            step=".01"
            min="0"
            class="shadow-sm"
            ref="long"
            type="number"
            v-model="model.long"
            v-validate="modelValidations.long"
            name="common_words.long"
            :error="getError('common_words.long', true)"
            :placeholder="`${$t('common_words.long')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-lg-6 col-xl-6`">
          <fg-input
            :label="`${$t('common_words.wide')}: *`"
            step=".01"
            min="0"
            class="shadow-sm"
            ref="long"
            type="number"
            v-model="model.wide"
            v-validate="modelValidations.wide"
            name="common_words.wide"
            :error="getError('common_words.wide', true)"
            :placeholder="`${$t('common_words.wide')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-lg-6 col-xl-6`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.crops') }}: *</label>
            <br />
            <el-select
              @change="selectAllFromSelect('model.crops_id', crops)"
              collapse-tags
              clearable
              filterable
              multiple
              class="select-primary custom-width-select shadow-sm required-crops"
              size="large"
              v-model="model.crops_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in crops"
                class="select-primary selected-all"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-distancing-type',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinPermissions,
    MixinValidations,
  ],
  data() {
    return {
      businessesInitial: [],
      crops: [],
      disabledField: false,
      model: {
        name: null,
        long: null,
        wide: null,
        businesses_id: [],
        businesses_names: [],
        crops_id: [],
      },
      modelValidations: {
        name: { required: true },
        long: {
          required: true,
          decimal: true,
          min_value: 0,
        },
        wide: {
          required: true,
          decimal: true,
          min_value: 0,
        },
      },
    };
  },
  methods: {
    getSelectAll() {
      this.crops = this.concatAll(this.crops.splice(1));
    },
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.crops_id)) {
            return this.validationInputsRequired('crops');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  mounted() {
    if (this.isCreate()) {
      Promise.all([Axios.getMasters('farms/crops')])
        .then(([responseCrops]) => {
          this.crops = this.concatAll(responseCrops.data.data);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, long, wide, crops } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        id,
        name,
        long,
        wide,
        crops_id: crops.map((crop) => crop.id),
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
